<!--
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-20 15:17:55
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" tableId="fbuPartnerActivity" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'name'">
        <a-button type="link" :title="text" @click="handleDetail(record)">{{ text }}</a-button>
      </template>
      <template v-if="column.dataIndex === 'startTime'">
        <p>{{ record.startTime }}-{{ record.endTime }}</p>
      </template>
      <template v-if="column.dataIndex === 'areaId'">
        <CustomerArea type="text" :value="text" />
      </template>
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_partner_activity_edit_btn'">
          编辑
        </a-button>
        <a-button type="link" @click="handleDelete(record)" v-permission="'fbu_partner_activity_del_btn'">
          删除
        </a-button>
      </template>
    </template>
  </cos-table>
  <partnerActivityFrom ref="partnerActivityRef" @success="success" :view="view" />
  <cos-footer-button :loading="loading" returnName="DcCosZbuPartnerManage">
    <a-button type="primary" @click="handleAdd()" :loading="loading" v-permission="'fbu_partner_activity_add_btn'"
      >新增市场活动</a-button
    >
  </cos-footer-button>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import CustomerArea from '@/components/CustomerArea'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { partnerActivityList, partnerActivityDelete } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import partnerActivityFrom from './partnerActivityFrom.vue'
const route = useRoute()
const table = ref()
const loading = ref(false)
const partnerActivityRef = ref()
defineProps({
  edit: {
    type: Boolean,
    default: false
  }
})
const view = ref(false)
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerActivityList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}

// 新增
const handleAdd = () => {
  view.value = false
  partnerActivityRef.value.toggle({
    partnerId: route.query.id,
    partnerName: route.query.name
  })
}
// 查看
const handleDetail = (row: PartnerManage['partnerContact']) => {
  view.value = true
  partnerActivityRef.value.toggle({
    ...row,
    partnerName: route.query.name
  })
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  view.value = false
  partnerActivityRef.value.toggle({
    ...row,
    partnerName: route.query.name
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerActivityDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
const success = (type?: 'add' | 'edit') => {
  if (type === 'add') {
    table.value.search()
  } else {
    table.value.fetch()
  }
}
const columns = ref([
  {
    title: '活动名称',
    dataIndex: 'name'
  },
  {
    title: '活动时间',
    dataIndex: 'startTime'
  },
  {
    title: '活动区域',
    dataIndex: 'areaId'
  },
  {
    title: '活动费用',
    dataIndex: 'cost'
  },
  {
    title: '是否参加',
    dataIndex: 'joinFlag',
    dicData: dataConfig.joinFlag
  },
  {
    title: '活动效果评估',
    dataIndex: 'resultEvaluate'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 140
  }
])
</script>
<script lang="ts">
export default { name: 'PartnerActivity' }
</script>
<style lang="scss" scoped></style>
